export interface MarketStatus { open: boolean; label: string; }

/** NYSE regular session: weekdays 09:30–16:00 America/New_York. Holidays not modeled. */
export const getMarketStatus = (now: Date = new Date()): MarketStatus => {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/New_York', weekday: 'short', hour: 'numeric', minute: 'numeric', hourCycle: 'h23',
  }).formatToParts(now);
  const get = (type: string) => parts.find(p => p.type === type)?.value ?? '';
  const weekday = get('weekday');
  const minutes = parseInt(get('hour'), 10) * 60 + parseInt(get('minute'), 10);
  const isWeekday = !['Sat', 'Sun'].includes(weekday);
  const open = isWeekday && minutes >= 9 * 60 + 30 && minutes < 16 * 60;
  return { open, label: open ? 'Market open' : 'Market closed' };
};
